import React from 'react';
import { useNavigate } from 'react-router-dom';

function FamilyChoice() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Join or Create a Family</h2>
        <div className="flex flex-col space-y-4 mt-8">
          <button
            className="btn-primary w-full text-lg py-3"
            onClick={() => navigate('/create-family')}
          >
            Create Family
          </button>
          <button
            className="btn-secondary w-full text-lg py-3"
            onClick={() => navigate('/join-family')}
          >
            Join a Family
          </button>
        </div>
      </div>
    </div>
  );
}

export default FamilyChoice; 